import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from './../../../assets/svg_main/info.svg';
import BlueInfoIcon from './../../../assets/svg_main/BlueInfoIcon.svg';
import RedInfoIcon from './../../../assets/svg_main/RedInfoIcon.svg';
import YellowInfoIcon from './../../../assets/svg_main/YellowInfoIcon.svg';
import './CustomTooltip.css'

const CustomTooltip = (props: any) => {
  return (
    <OverlayTrigger placement="bottom" overlay={<Tooltip id="custom-tooltip">{props.text}</Tooltip>}>
      <span
        className="text-truncate d-inline-block custom-info-trigger"
        style={{ maxWidth: '90%' }}
      >
       <InfoIcon />
      </span>
    </OverlayTrigger>
  );
};

export const CustomTooltipComponent = ({
  text = '',
  placement = 'top',
  style={},
  children,
}: any) => {
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip id="custom-tooltip">{text}</Tooltip>}>
      <span
        className="text-truncate d-inline-block custom-info-trigger"
        style={{ maxWidth: '90%', ...style  }}
      >
       {children}
      </span>
    </OverlayTrigger>
  );
};
 
export const BlueInfoIconTooltip = ({text='', placement='top', style={}}: any) => {
  return <CustomTooltipComponent text={text} placement={placement} style={style}><BlueInfoIcon /></CustomTooltipComponent>
};
 
export const RedInfoIconTooltip = ({text='', placement='top', style={}}: any) => {
  return <CustomTooltipComponent text={text} placement={placement}  style={style}><RedInfoIcon /></CustomTooltipComponent>
  };
 
export const YellowInfoIconTooltip = ({text='', placement='top', style={}}: any) => {
  return <CustomTooltipComponent text={text} placement={placement}  style={style}><YellowInfoIcon /></CustomTooltipComponent>  
};


export default CustomTooltip;
